import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import KlarnaPaymentCategoryAndroid from './klarnaPaymentCategory.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='updateCollectedData(collectableData: KlarnaPaymentCollectableData)' mdxType="Item">
      <p>{`Update component with collected data by passing implementations of sealed interface.
This method can be called at any point, even if you have only partially collected data.
To validate the partially collected data, you can refer to the
`}<a parentName="p" {...{
          "href": "/docs/sdk/android/2.x.x/primerHeadlessUniversalCheckout/klarna/klarnaProvideKlarnaComponent#klarnacomponent.componentValidationStatus:-FlowlessPrimerValidationStatuslessKlarnaPaymentCollectableDatagreatergreater"
        }}>{`componentValidationStatus`}</a>{`
and receive the validation status when it's updated.`}</p>
      <Group summary='sealed interface KlarnaPaymentCollectableData' mdxType="Group">
	<Item title='PaymentOptions' mdxType="Item">
		A data class representing the step of choosing a Klarna Payment method.
		<Group summary='Properties' open mdxType="Group">
			<Item title='context' subtitle='Context' mdxType="Item">
				Context required for the creation of the payment view.
			</Item>
			<Item title='returnIntentUrl' subtitle='String' mdxType="Item">
				Url used by third-party apps to build the intent for returning to the app.
			</Item>
			<Item title='paymentCategory' subtitle='KlarnaPaymentCategory' mdxType="Item">
				Payment category required for session creation.
				<KlarnaPaymentCategoryAndroid mdxType="KlarnaPaymentCategoryAndroid" />
			</Item>
		</Group>
	</Item>
	<Item title='FinalizePayment' mdxType="Item">
		Object representing the step of finalizing the Klarna payment.
	</Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      